module.exports = __webpack_public_path__ + "static/media/cyprus-green.744a4892.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/space-gray-aluminum-case/cyprus-green.jpeg
// module id = 2033
// module chunks = 0